import React, { useState } from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const [activeTab, setActiveTab] = useState('privacy');
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = sectionId => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  const privacySections = [
    {
      id: 'information',
      title: 'Information We Collect',
      content: `We collect several types of information from and about users of our Platform, including:
      • Personal information such as name, email address, and contact details that you provide when registering.
      • Educational information including course selections, progress, and performance data.
      • Technical information such as IP address, browser type, and device information.
      • Usage data about how you interact with our platform.`,
    },
    {
      id: 'usage',
      title: 'How We Use Your Information',
      content: `We use the information we collect to:
      • Provide, maintain, and improve our educational services.
      • Process enrollments and manage your account.
      • Personalize your learning experience.
      • Communicate with you about courses, updates, and support.
      • Analyze usage patterns to enhance our platform.
      • Comply with legal obligations.`,
    },
    {
      id: 'sharing',
      title: 'Information Sharing',
      content: `We may share your information with:
      • Instructors and educational partners to facilitate your learning.
      • Service providers who perform services on our behalf.
      • Legal authorities when required by law.
      • We do not sell your personal information to third parties.`,
    },
    {
      id: 'security',
      title: 'Data Security',
      content: `We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure. We strive to use commercially acceptable means to protect your personal information but cannot guarantee absolute security.`,
    },
    {
      id: 'cookies',
      title: 'Cookies and Tracking',
      content: `We use cookies and similar tracking technologies to track activity on our platform and hold certain information. Cookies are files with small amounts of data which may include an anonymous unique identifier. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.`,
    },
    {
      id: 'children',
      title: "Children's Privacy",
      content: `Our platform is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us.`,
    },
    {
      id: 'changes',
      title: 'Changes to Privacy Policy',
      content: `We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.`,
    },
    {
      id: 'contact',
      title: 'Contact Us',
      content: `If you have any questions about this Privacy Policy, please contact us at: support@klassonline.com`,
    },
  ];

  const termsAndConditionsSections = [
    {
      id: 'acceptance',
      title: 'Acceptance of Terms',
      content: `By accessing or using our Klass Online platform, you agree to be bound by these Terms and Conditions. If you disagree with any part of the terms, you may not access the service.`,
    },
    {
      id: 'accounts',
      title: 'User Accounts',
      content: `When you create an account with us, you must provide accurate, complete, and current information. You are responsible for safeguarding the password and for all activities that occur under your account. You must notify us immediately of any unauthorized use of your account.`,
    },
    {
      id: 'conduct',
      title: 'User Conduct',
      content: `You agree not to:
      • Use the platform in any way that violates applicable laws or regulations.
      • Impersonate any person or entity or falsely state your affiliation.
      • Interfere with or disrupt the service or servers connected to the service.
      • Share your account credentials with others or allow others to access your account.
      • Engage in academic dishonesty or plagiarism.`,
    },
    {
      id: 'content',
      title: 'Intellectual Property',
      content: `All content on the platform, including text, graphics, logos, and software, is the property of our company or our content suppliers and is protected by copyright and intellectual property laws. You may not reproduce, distribute, or create derivative works without our express permission.`,
    },
    {
      id: 'payment',
      title: 'Payment Terms',
      content: `For paid courses, payment must be made according to the terms specified at the time of purchase. All payments are non-refundable unless otherwise specified in our refund policy. We reserve the right to modify pricing at any time.`,
    },
    {
      id: 'termination',
      title: 'Termination',
      content: `We may terminate or suspend your account immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason at our sole discretion.`,
    },
    {
      id: 'disclaimer',
      title: 'Disclaimer of Warranties',
      content: `The platform is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee that the platform will be uninterrupted, secure, or error-free.`,
    },
    {
      id: 'limitation',
      title: 'Limitation of Liability',
      content: `To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the platform.`,
    },
    {
      id: 'governing',
      title: 'Governing Law',
      content: `These Terms shall be governed by and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law provisions.`,
    },
    {
      id: 'changes-terms',
      title: 'Changes to Terms',
      content: `We reserve the right to modify these terms at any time. We will provide notice of significant changes by posting an updated version on our platform. Your continued use after such changes constitutes your acceptance of the new terms.`,
    },
  ];

  const renderSections = sections => {
    return sections.map(section => (
      <div className="policy-section" key={section.id}>
        <div className="section-header" onClick={() => toggleSection(section.id)}>
          <h3>{section.title}</h3>
          <span className={`arrow ${expandedSections[section.id] ? 'expanded' : ''}`}>&#9660;</span>
        </div>
        <div className={`section-content ${expandedSections[section.id] ? 'expanded' : ''}`}>
          <p>{section.content}</p>
        </div>
      </div>
    ));
  };

  return (
    <div className="policy-container">
      {/* <div className="policy-header">
        <h1>Legal Information</h1>
       
      </div> */}

      <div className="tabs">
        <button
          className={activeTab === 'privacy' ? 'active' : ''}
          onClick={() => setActiveTab('privacy')}
        >
          Privacy Policy
        </button>
        <button
          className={activeTab === 'terms' ? 'active' : ''}
          onClick={() => setActiveTab('terms')}
        >
          Terms & Conditions
        </button>
      </div>

      <div className="policy-content">
        {activeTab === 'privacy' ? (
          <>
            <div className="policy-intro">
              <p>
                At Klass Online, we are committed to protecting your privacy. This Privacy Policy
                explains how we collect, use, and safeguard your information when you use our online
                educational platform.
              </p>
            </div>
            {renderSections(privacySections)}
          </>
        ) : (
          <>
            <div className="policy-intro">
              <p>
                Please read these Terms and Conditions carefully before using our Klass Online . By
                accessing or using our service, you agree to be bound by these terms.
              </p>
            </div>
            {renderSections(termsAndConditionsSections)}
          </>
        )}
      </div>

      <div className="policy-footer">
        <button className="print-button" onClick={() => window.print()}>
          Print Document
        </button>
        <p>© 2025 Klass Online . All rights reserved.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
